import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import "./index.css";
import App from "./App";
import LandingPage from "./pages/LandingPage";
import MainLayout from "./components/Dashboard/Layouts/MainLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUp";
import ProfilePage from "./components/Dashboard/Pages/ProfilePage";
import AddSchedule from "./components/Dashboard/Pages/Coatch/AddSchedule";
import AddSession from "./components/Dashboard/Pages/Coatch/AddSession";
import AddTrainingPage from "./components/Dashboard/Pages/Player/AddTrainingPage";
import AdminPage from "./components/Dashboard/Pages/Admin/AdminDashboard";
import PlayerSchedule from "./components/Dashboard/Pages/Player/PlayerSchedule";
import ManagerCampView from "./components/Dashboard/Pages/Manger/ViewCamps";
import ManagerTechStaff from "./components/Dashboard/Pages/Manger/TechStaff";
import ManagerTrainingReport from "./components/Dashboard/Pages/Manger/TrainingReport";
import ManagerTeamReport from "./components/Dashboard/Pages/Manger/TeamReport";
import ManagerPlayerReport from "./components/Dashboard/Pages/Manger/PlayerReport";
import ManagerCampsInfo from "./components/Dashboard/Pages/Manger/ManagerCampSummary";
import TEST from "./components/Dashboard/Pages/Manger/buildT";
import SignTranslatorPage from "./components/Dashboard/Pages/SignTranslatorPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />, // Centralized session management
    children: [
      {
        path: "",
        element: <LandingPage />,
      },
      {
        path: "sign-in",
        element: <LoginPage />,
      },
      {
        path: "sign-up",
        element: <SignUpPage />,
      },
      {
        path: "dashboard",
        element: (
          <ProtectedRoute roles={["coach", "player", "admin", "manager"]}>
            <MainLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <ProfilePage />,
          },
          {
            path: "add-schedule",
            element: (
              <ProtectedRoute roles={["coach"]}>
                <AddSchedule />
              </ProtectedRoute>
            ),
          },
          {
            path: "add-schedule/:id",
            element: (
              <ProtectedRoute roles={["coach"]}>
                <AddSession />
              </ProtectedRoute>
            ),
          },
          {
            path: "train",
            element: (
              <ProtectedRoute roles={["player"]}>
                <PlayerSchedule />
              </ProtectedRoute>
            ),
          },
          {
            path: "sabt/:date",
            element: (
              <ProtectedRoute roles={["player"]}>
                <AddTrainingPage />
              </ProtectedRoute>
            ),
          },
          {
            path: "admin",
            element: (
              <ProtectedRoute roles={["admin"]}>
                <AdminPage />
              </ProtectedRoute>
            ),
          },
          {
            path: "view-camp",
            element: (
              <ProtectedRoute roles={["manager"]}>
                <ManagerCampView />
              </ProtectedRoute>
            ),
          },
          {
            path: "technical-staff",
            element: (
              <ProtectedRoute roles={["manager"]}>
                <ManagerTechStaff />
              </ProtectedRoute>
            ),
          },
          {
            path: "train-report",
            element: (
              <ProtectedRoute roles={["manager"]}>
                <ManagerTrainingReport />
              </ProtectedRoute>
            ),
          },
          {
            path: "team-report",
            element: (
              <ProtectedRoute roles={["manager"]}>
                <ManagerTeamReport />
              </ProtectedRoute>
            ),
          },
          {
            path: "players-report",
            element: (
              <ProtectedRoute roles={["manager"]}>
                <ManagerPlayerReport />
              </ProtectedRoute>
            ),
          },
          {
            path: "test",
            element: (
              <ProtectedRoute roles={["manager"]}>
                <TEST />
              </ProtectedRoute>
            ),
          },
          {
            path: "test1",
            element: (
              <ProtectedRoute roles={["manager"]}>
                <TEST />
              </ProtectedRoute>
            ),
          },
          {
            path: "view-camps-info",
            element: (
              <ProtectedRoute roles={["manager"]}>
                <ManagerCampsInfo />
              </ProtectedRoute>
            ),
          },
          {
            path: "sign-translator",
            element: (
              <ProtectedRoute roles={["coach", "player", "admin", "manager"]}>
                <SignTranslatorPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
